import { jsx as _jsx } from "react/jsx-runtime";
import GetReservationDrawer from "../drawers/GetReservationDrawer";
import DateSelectionCalendar from "./DateSelectionCalendar";
import DayEventBookingContent from "./DayEventBookingContent";
const VenueReservationDrawer = ({ isOpen, onOpen, onClose, dayEvent, pubId, selectedDate, onDateChange, onContinue, onDayEventNavigate, pubColors, }) => {
    const hasDayEvent = !!(dayEvent === null || dayEvent === void 0 ? void 0 : dayEvent.uuid) && !!pubId;
    return (_jsx(GetReservationDrawer, { isOpen: isOpen, onOpen: onOpen, onClose: onClose, header: hasDayEvent ? "Lock In Your Spot" : undefined, pubColors: pubColors, drawerBody: hasDayEvent ? (_jsx(DayEventBookingContent, { pubId: pubId, dayEventUuid: dayEvent.uuid, onNavigate: (path) => {
                onClose();
                setTimeout(() => {
                    onDayEventNavigate(path);
                }, 100);
            }, pubColors: pubColors })) : (_jsx(DateSelectionCalendar, { selectedDate: selectedDate, onDateChange: onDateChange, pubColors: pubColors, onContinue: onContinue })) }));
};
export default VenueReservationDrawer;
